import React from 'react';
import { Chip } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { Audience } from 'modules/audiences';
import { SelectOption } from 'modules/common/models';
import { AnalyticsReportFilters, AudienceStatsFilterv1 } from 'modules/insights';

interface FilterSelectionProps {
    filters: Partial<AnalyticsReportFilters | AudienceStatsFilterv1>;
    topics?: string[] | undefined;
    availableTopics?: SelectOption[];
    audiences?: Audience[];
    onClearAudience?: (audienceId: string) => void;
    onClearTopic?: (topicId: string) => void;
}

const FilterSelection: React.FC<FilterSelectionProps> = ({
    topics,
    availableTopics,
    audiences,
    filters,
    onClearAudience,
    onClearTopic,
}) => {
    if ((!topics || topics.length === 0) && (!audiences || audiences.length === 0)) {
        return null;
    }

    return (
        <>
            {topics && topics.length > 0 && availableTopics && topics.map((selectedTopic: string) => {
                const topicLabel = availableTopics.find((topic: SelectOption) => topic.key === selectedTopic)?.text;
                
                return (
                    <Chip
                        key={selectedTopic}
                        label={topicLabel}
                        onDelete={onClearTopic ? () => onClearTopic(selectedTopic) : undefined}
                        deleteIcon={<CloseIcon />}
                    />
                );
            })}
            {audiences && audiences.length > 0 && filters.audiences && filters.audiences.length > 0 && audiences.map((audience: Audience) =>
                filters.audiences!.includes(audience.id) && (
                    <Chip
                        key={audience.id}
                        label={audience.displayName}
                        onDelete={onClearAudience ? () => onClearAudience(audience.id) : undefined}
                        deleteIcon={<CloseIcon />}
                    />
                )
            )}
        </>
    );
};

export default FilterSelection;